import { ServicoClienteModel } from "./servico-cliente-model";

export class ServicoModel {
    constructor(
  
      public servicoCliente: ServicoClienteModel = new ServicoClienteModel()
      
    ) {}
  }
  